import axios from 'axios'
import { router } from '@/router'
// 创建axios实例
const service = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  timeout: 10000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 从 localStorage 获取 token
    const token = localStorage.getItem('token')
    if (token && config.headers) {
      // 确保 headers 存在才添加 Authorization
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)
// 响应拦截器
service.interceptors.response.use(
  response => response.data,
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 400:
          console.error('错误请求 (400)', error.response.data)
          break
        case 401:
          console.error('未授权 (401)', error.response.data)
          localStorage.removeItem('token') // 清除无效 token
          router.push('/login') // 跳转登录页
          break
        case 404:
          console.error('请求地址未找到 (404)', error.response.data)
          break
        case 500:
          console.error('服务器错误 (500)', error.response.data)
          router.push('/error') // 跳转自定义错误页
          break
        default:
          console.error('其他错误', error.response.data)
          break
      }
    } else if (error.request) {
      console.error('没有收到响应', error.request)
    } else {
      console.error('请求设置错误', error.message)
    }

    return Promise.reject(error)
  }
)

export default service
